import { useContext, useEffect } from 'react'
import { useStore } from 'zustand'

import { useAsyncError } from '@/modules/errors'
import type { InsightsStore } from '@/modules/projects'
import { ProjectContext } from '../components/ProjectStoreContext'

const useInsightsStore = <T>(selector: (state: InsightsStore) => T): T => {
  const stores = useContext(ProjectContext)
  const store = stores?.insightsStore

  if (!store) {
    throw new Error('useInsightsStore must be used within ProjectProvider')
  }

  return useStore(store, selector)
}

export const useInsights = () => useInsightsStore((state) => state.insights)

export const useInsightsActions = () =>
  useInsightsStore((state) => state.actions)

export const useInsightsMutations = () =>
  useInsightsStore((state) => state.mutations)

export const useInsightsLoaders = () =>
  useInsightsStore((state) => state.loaders)

export const useInsightsMutating = () =>
  useInsightsStore((state) => state.mutating)

export const useLoadingInsights = () =>
  useInsightsStore((state) => state.loadingInsights)

export const useFetchInsights = (slug: string) => {
  const { fetchInsights } = useInsightsLoaders()
  const throwError = useAsyncError()

  useEffect(() => {
    fetchInsights(slug).catch(throwError)
  }, [])
}
